<!-- 签约产品列表 -->
<template>
  <div>
    <div
      class="card-item-wrapper"
      v-for="product in productList"
      :key="product.bizProductNo"
    >
      <div class="title-container">
        <img
          class="ems-post-logo"
          src="https://ump.ems.com.cn/newmail-resources/images/logo/post-ems-logo@3x.png"
        />
        <span class="title-text">{{ product.bizProductName }}</span>
      </div>
      <div class="price-title">
        <span class="unit">¥</span>
        <span class="price">{{ product.feeMap.totalFee }}</span>
      </div>
      <div class="tag-wrapper">
        <div class="danger-tag-item" v-show="product.insured === '0'">
          此产品暂不支持保价
        </div>
        <div class="tag-item">运费¥{{ product.feeMap.totalFee }}</div>
        <!-- <div class="tag-item">基础保¥{{}}</div> -->
        <div class="tag-item">
          计费重量{{ product.feeMap.feeWeight / 1000 }}kg
        </div>
      </div>
      <div class="bottom-wrapper" v-show="product.time">
        <div class="effect-tips" v-show="product.time">
          参考时效{{ product.time }}天
        </div>
        <!-- <div class="tips">不支持快递员上门取件，仅可自寄</div> -->
      </div>
    </div>
    <no-result-box
      v-show="productList.length === 0 && isCheck"
      resultNull="暂无结果，了解更多产品，敬请查看"
    >
      <div class="tips">
        <span @click="handleToPage('zhongsuhuoyun')">《中速快运货运类》</span>
        <span @click="handleToPage('zhongyouhaiwaicang')">《中邮海外仓》</span>
        <span @click="handleToPage('zhongyoufba')">《中邮FBA》</span>
      </div>
    </no-result-box>
  </div>
</template>

<script>
import NoResultBox from '@/components/noResult/NoResultBox.vue'
export default {
  name: 'priviteProductCard',
  props: {
    productList: {
      type: Array,
      default: () => []
    },
    isCheck: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    NoResultBox
  },
  data () {
    return {}
  },
  methods: {
    handleToPage (type) {
      this.$router.push({
        path: 'introducePagev2',
        query: {
          type: type
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
